import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FieldCombo from '../combos/FieldCombo';
import SchoolClassCombo from '../combos/SchoolClassCombo';
import { Checkbox } from 'primereact/checkbox';
import * as XLSX from "xlsx";        
import EduMonthCombo from '../combos/EduMonthCombo';
import FaDate from '../shared/FaDate';
import DisiplineScoreSave from './DisiplineScoreSave'
import { Col, Form, Row } from 'react-bootstrap';
import ShowVideo from '../shared/ShowVideo';

export default function SchoolDisiplineScores(props) {
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editFormVisible, setEditFormVisible] = useState(false);
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [deleting, setDeleting] = useState(false);

  
  const [items, setItems] = useState([]);

  const [schoolClassId, setSchoolClassId] = useState("");
  const [schoolClassDegree, setSchoolClassDegree] = useState(-1);
  const [continualTestId, setContinualTestId] = useState("");
  const [month, setMonth] = useState(null);
  
  useEffect(() => {
  }, []);
  const searchFinalScoreStates = function(){
    if((month == null)||(month == {})||(month == "")||(month <= 0)){
      setErorVisible(true);
      setErrorMessage("ماه تحصیلی را مشخص نمائید");
      return;
    }

      var params = {login:util.getTrustedUser(), monthInd:month};
      var url = config.Server+`/school/month/disipline-score/state/list`;

      setLoading(true);
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                var items = response.data;
                setLoaded(true);
                setLoading(false);
                setItems(items);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  //setLoading(false);
              }
          })
          .catch(error => {
              setLoading(false);
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              //setLoading(false);
          });
  }
  const onContinualTestChanged = function (scId, id){
    var tmp = {...items};
    for(var i=0;i<tmp.items.length;i++){
      var state = tmp.items[i];
      if((state.schoolClass.id == scId)){
        tmp.items[i].done = true;
        tmp.items[i].disiplineScoreId = id;
      }
    }
    setItems(tmp);
  }
  const showEditForm = function (scId, deg, id){
    setSchoolClassId(scId);
    setSchoolClassDegree(deg);
    setContinualTestId(id);
    setEditFormVisible(true);
  }
  const onRowDeleteClick = function(scId, id) {
    setSchoolClassId(scId);
    setContinualTestId(id);
    setConfirmDeleteVisible(true);
  }
  const deleteItem = function(){
    setDeleting(true);
    var params = {login:util.getTrustedUser(), id:continualTestId};
    var url = config.Server+`/school/month/disipline-score/delete`;
      axios
          .post(url, params )
          .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                var tmp = {...items};
                for(var i=0;i<tmp.items.length;i++){
                  var state = tmp.items[i];
                  if((state.schoolClass.id == schoolClassId)){
                    tmp.items[i].done = false;
                    tmp.items[i].disiplineScoreId = "";
                  }
                }
                setItems(tmp);
                
                setDeleting(false);
                setConfirmDeleteVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setDeleting(false);
            }
          })
          .catch(error => {
            setDeleting(false);
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
          });
  }
  const onDeleteConfirm_Accept = function(){
    deleteItem();
  }
  const onDeleteConfirm_Reject = function(){
      if(deleting) return;
      setConfirmDeleteVisible(false);
  }
  return(      
    <> 
    <ShowVideo videoId="disipline_book" top={65} md={6} />   
      <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>انضباط نهائی ماهانه</div>
      {
        loaded?
        <>
        <div className="" style={{ width:"calc(100% - 0px)"}}>
          <div style={{backgroundColor:'#e9edffff', padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
              <Row>
                <Col>
                  <div style={{float:'right', margin:'10px', display:'block', direction:"ltr", textAlign:"right", position:"relative", width:"calc(100% - 20px)"}}>
                    <Button style={{width:"200px"}} label="انتخاب ماه تخصیلی" icon="pi pi-check" onClick={()=>setLoaded(false)} loading={loading} severity="primary" iconPos="right" />
                    <div style={{position:"absolute", right:"220px", top:"10px", direction:"rtl"}}>
                      [{month}]&nbsp;{util.getMonthName(month)}
                    </div>
                  </div>
                </Col>
              </Row>
          </div>
        </div>
          <div className="card" style={{overflow:"scroll", marginTop:"10px"}}>
            <table style={{borderCollapse:"collapse", margin:"10px"}}>
              <tr>
                <td style={{padding:"5px", border:"1px solid #b0b0b0", textAlign:"center", width:"30px", backgroundColor:"#808080", color:"#ffffff"}}>#</td>
                <td style={{padding:"5px", border:"1px solid #b0b0b0", textAlign:"center", backgroundColor:"#808080", color:"#ffffff"}}>کلاس</td>
                <td style={{padding:"5px", border:"1px solid #b0b0b0", textAlign:"center", width:"40px", backgroundColor:"#808080", color:"#ffffff"}}>ثبت</td>
                <td style={{padding:"5px", border:"1px solid #b0b0b0", textAlign:"center", width:"130px", backgroundColor:"#808080", color:"#ffffff"}}>&nbsp;</td>
                <td style={{padding:"5px", border:"1px solid #b0b0b0", textAlign:"center", width:"65px", backgroundColor:"#808080", color:"#ffffff"}}>&nbsp;</td>
                <td >&nbsp;</td>
              </tr>
              {
                items.items.map((row, index)=>{
                  return(
                    <tr>
                      <td style={{padding:"5px", border:"1px solid #b0b0b0", textAlign:"center", backgroundColor:(index%2==1)?"#eee":"#fff"}}>{(index+1)}</td>
                      <td style={{padding:"5px", border:"1px solid #b0b0b0", textAlign:"center", backgroundColor:(index%2==1)?"#eee":"#fff"}}>{row.schoolClass.name}</td>
                      <td style={{padding:"5px 10px", border:"1px solid #b0b0b0", textAlign:"center", backgroundColor:(index%2==1)?"#eee":"#fff"}}>
                        {row.done?
                        <div style={{width:"20px", height:"20px", backgroundColor:"#44ee44", borderRadius:"50%"}}></div>
                        :
                        <div style={{width:"20px", height:"20px", backgroundColor:"#ee4444", borderRadius:"50%"}}></div>
                        }
                      </td>
                      <td style={{padding:"5px", border:"1px solid #b0b0b0", textAlign:"center", backgroundColor:(index%2==1)?"#eee":"#fff"}}>
                        <Button onClick={()=>showEditForm(row.schoolClass.id, row.schoolClass.degree, row.disiplineScoreId)} >ثبت انضباط</Button>
                      </td>
                      <td style={{padding:"5px", border:"1px solid #b0b0b0", textAlign:"center", backgroundColor:(index%2==1)?"#eee":"#fff"}}>
                        <Button onClick={()=>onRowDeleteClick(row.schoolClass.id, row.disiplineScoreId)} severity='danger' >حذف</Button>
                      </td>
                      <td ></td>
                    </tr>
                  )
                })
              }
            </table>
          </div>
        </>
        :
        <div className="" style={{ width:"calc(100% - 0px)"}}>
          <div style={{backgroundColor:'#e9edffff', padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
              <Row>
                <Col md={3}>
                  <EduMonthCombo value={month} onChange={(value)=>{setMonth(value)}} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <div style={{float:'right', margin:'10px', display:'block', direction:"ltr", textAlign:"right"}}>
                    <Button label="ادامه" icon="pi pi-search" onClick={()=>searchFinalScoreStates()} loading={loading} severity="primary" iconPos="right" />
                  </div>
                  
                </Col>
              </Row>
          </div>
        </div>
      }
      {
        editFormVisible?
        <DisiplineScoreSave schoolClassId={schoolClassId} schoolClassDegree={schoolClassDegree} monthInd={parseInt(month)} onChange={(scId, id)=>{onContinualTestChanged(scId, id)}} onClose={()=>setEditFormVisible(false)} />
        :
        <></>
      }
      <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
      <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
    </>  
  );
}
